export const religionTypeConstants = [
  { name: "Islam", value: "Islam" },
  { name: "Hinduism", value: "Hinduism" },
  { name: "Christianity", value: "Christianity" },
  { name: "Buddhism", value: "Buddhism" },
  { name: "Others", value: "Others" },
];
